export default __webpack_public_path__ + "static/media/Helm of Ardent Fire.83c79f5c.jpg";